<template>
  <div v-if="status === 'NOT_AUTHORIZED'">
    <NotAuth></NotAuth>
  </div>
  <div v-else :class="{ 'o-card__no-shadow': noCard }" class="o-card my-4">
    <div
      class="row u-align-items-center row-no-gutters u-justify-content-flex-end"
    >
      <div
        class="es-xs-12 es-sm-5 es-md-3 es-md-3"
        :class="{ 'es-md-6': noSearch }"
      >
        <div class="o-card__title mb-0">
          <h4 v-if="title !== ''">
            {{ title }}
            <loading
              style="display: inline !important"
              class="u-margin-left-xsmall"
              sm
              v-if="loading"
            ></loading>
            <Chip v-else>{{ countItem }}</Chip>
          </h4>
          <p v-if="description !== ''">
            <small>{{ description }}</small>
          </p>
        </div>
      </div>
      <div class="es-xs-12 es-sm-2 es-md-2 es-lg-2 u-text-align-right">
        <div
          v-if="filterSlot && filterWithSearch"
          class="u-display-none-sm-down"
        >
          <slot name="filter"></slot>
        </div>
        <p class="o-table__choose-user" v-if="checkedList.length !== 0">
          {{
            $t("choosedUser", {
              count: selectedAll ? countItem : checkedList.length,
            })
          }}
          <small
            @click="SET_CHECKED_ALL(true, true)"
            v-if="
              !selectedAll &&
              countItem !== checkedList.length &&
              checkedList.length !== 0 &&
              countItem !== items.length
            "
            class="o-table__choose-all"
          >
            {{ $t("chooseAll", { count: countItem }) }}
          </small>
        </p>
      </div>
      <div
        v-if="newButtonSlot"
        class="es-xs-12 es-sm-5 es-md-4 es-lg-4 u-text-align-right"
      >
        <div>
          <slot name="new-button"></slot>
        </div>
      </div>
      <div
        v-if="!noSearch"
        :class="{
          'es-xs-12 es-sm-12 es-md-12 es-lg-12': title === '',
          'es-xs-12 es-sm-6 es-md-3 es-lg-3': title !== '',
        }"
      >
        <form @submit="SET_SUBMIT" class="u-padding-left-xsmall">
          <BaseInput
            size="sm"
            type="text"
            block
            name="search"
            v-model="search"
            icon="search"
            @keyup="SET_SUBMIT"
            :placeholder="searchPlaceholder"
          ></BaseInput>
        </form>
      </div>
    </div>
    <!-- <div>
      <Pagination
        @change="SET_PAGINATION"
        :page="page"
        :pages="pages"
        ul-class="c-pagination"
        li-class="c-pagination__list"
        active-class="c-pagination__list--active"
        aClass="c-pagination__list__action"
      ></Pagination>
    </div> -->
    <div v-if="filterSlot && !filterWithSearch" class="u-display-none-sm-down">
      <slot name="filter"></slot>
    </div>
    <div class="u-text-align-right u-margin-top-xsmall">
      <Button
        v-if="filterSlot"
        class="u-display-none-sm-up"
        @click="showFilterDrawer = true"
        variant="primary"
      >
        <i class="icofont-filter"></i> {{ $t("filter.title") }}</Button
      >
    </div>
    <drawer
      persistent
      :title="$t('filter.title')"
      v-model="showFilterDrawer"
      align="bottom"
    >
      <slot name="filter"></slot>
    </drawer>
    <div class="o-table">
      <Header
        :i18n="i18n"
        v-if="!smallTable"
        @change:scroll="(e) => (scrollLeft = e)"
        @change:checkedAll="SET_CHECKED_ALL"
        @change:sort="SET_CHANGE_SORT"
        :scrollLeft="scrollLeft"
        :checkedList="checkedList"
        :items="items"
        :checkable="checkable"
        :singleCheckable="singleCheckable"
        :allChecked="allChecked"
        :headers="headers"
      ></Header>
      <div v-if="loading" class="u-text-align-center u-margin-top">
        <span class="loader primary-loading small-loader"></span>
      </div>
      <Body
        :i18n="i18n"
        @change:checked="SET_CHECK_LIST"
        :checkedList="checkedList"
        :headers="headers"
        @click:row="$emit('click:row', $event)"
        :smallTable="smallTable"
        :checkable="checkable"
        :singleCheckable="singleCheckable"
        :checkedKey="checkedKey"
        :scrollLeft="scrollLeft"
        :items="items"
        v-else-if="headers.length !== 0 && items.length !== 0"
      >
        <template
          v-slot:[header]="{ item, index }"
          v-for="(header, i) in scopedSlots"
        >
          <div :key="'a' + i">
            <slot :item="item" :index="index" :name="header"></slot>
          </div>
        </template>
      </Body>
      <div class="u-text-align-center u-margin-top-xlarge u-color-muted" v-else>
        <img class="u-no-found-image" :src="noFoundImage" :alt="emptyText" />
        <p class="u-margin-top">
          <small class="u-font-size-xsmall">{{ emptyText }}</small>
        </p>
      </div>
      <div v-if="!noCaption" class="o-table__footer-caption">
        <i class="o-table__footer-caption__text">{{ captionText }}</i>
      </div>
      <div>
        <Pagination
          @change="SET_PAGINATION"
          :page="page"
          :pages="pages"
          ul-class="c-pagination"
          li-class="c-pagination__list"
          active-class="c-pagination__list--active"
          aClass="c-pagination__list__action"
        ></Pagination>
      </div>
    </div>
    <div class="o-table__footer-caption" v-if="!noCaption">
      <i class="o-table__footer-caption__text">{{
        $t("foundItem", { count: countItem })
      }}</i>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Body from "./Body.vue";
import BaseInput from "@base/Inputs/BaseInput.vue";
import Pagination from "../Pagination.vue";
import Chip from "../Chip.vue";
import Drawer from "../Drawer.vue";
import Button from "../Button.vue";
import NotAuth from "@/components/Base/NotAuth.vue";
const noFoundImage = require("@/assets/images/nofound.png");

export default {
  data() {
    return {
      noFoundImage,
      init: false,
      search: "",
      selectedAll: false,
      showFilterDrawer: false,
      filterSlot: false,
      newButtonSlot: false,
      isVisibleContextmenu: false,
      searchTimeout: -1,
      scrollLeft: 0,
      countItem: 0,
      scopedSlots: [],
      checkedList: [],
      headersData: [],
    };
  },
  props: {
    title: {
      default: "",
    },
    description: {
      default: "",
    },
    searchPlaceholder: {
      default: "",
    },
    captionText: {
      default: "",
    },
    headers: {
      default: () => [],
    },
    items: {
      default: () => [],
    },
    noCard: {
      default: false,
      type: Boolean,
    },
    noSearch: {
      default: false,
      type: Boolean,
    },
    noCaption: {
      default: false,
      type: Boolean,
    },
    smallTable: {
      default: false,
      type: Boolean,
    },
    checkable: {
      default: false,
      type: Boolean,
    },
    singleCheckable: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    i18n: {
      default: false,
      type: Boolean,
    },
    filterWithSearch: {
      default: false,
      type: Boolean,
    },
    status: {
      default: "success",
      type: String,
    },
    emptyText: {
      type: String,
      default: function () {
        return this.$t("noFoundData");
      },
    },
    searchValue: {
      default: "",
    },
    checkedKey: {
      default: "id",
    },
    count: {
      default: 0,
    },
    page: {
      default: 1,
    },
    pages: {
      default: 0,
    },
    checkValue: {
      default: () => [],
    },
  },
  watch: {
    items() {
      if (this.count === 0) this.countItem = this.items.length;
      else this.countItem = this.count;
    },
    checkedList(data) {
      this.$emit("change:checkedList", data);
      this.EMIT_REQUEST("change:checkedList");
    },
    searchValue(data) {
      this.search = data;
    },
    checkValue: {
      handler(data) {
        console.log("burası değiştir mi?");

        this.checkedList = data;
      },
      deep: true,
    },
  },
  computed: {
    allChecked() {
      return this.checkedList.length === this.items.length;
    },
  },
  methods: {
    EMIT_REQUEST(action, headers = this.headersData) {
      if (!this.init) return;

      setTimeout(() => {
        const sort = headers.find((h) => h.sort);
        this.$emit(
          "request",
          {
            action,
            sort,
            headers,
            selectedAll: this.selectedAll,
            checkedList: this.checkedList,
            search: this.search,
            count: this.countItem,
            page: this.page,
          },
          action
        );
      }, 100);
    },
    SET_PAGINATION(page) {
      this.$emit("change:page", page);
      this.EMIT_REQUEST("change:page");
    },
    SET_CHANGE_SORT(header, headers) {
      this.headersData = headers;
      this.$emit("change:sort", headers);
      this.EMIT_REQUEST("change:sort", headers);
    },
    SET_CHECKED_ALL(data, getAllItem = false) {
      this.selectedAll = getAllItem;
      if (getAllItem) this.$emit("change:selectAllWithoutPage", true);
      if (data) {
        this.checkedList = [...this.items];
      } else {
        this.$emit("change:selectAllWithoutPage", false);
        this.checkedList = [];
      }
      this.EMIT_REQUEST("change:selectAllWithoutPage");
    },
    SET_CHECK_LIST(data) {
      this.selectedAll = false;
      this.$emit("change:selectAllWithoutPage", false);
      const index = this.checkedList.findIndex(
        (item) => item[this.checkedKey] === data[this.checkedKey]
      );
      if (index === -1 && this.singleCheckable) {
        this.checkedList = [];
        this.checkedList.push(data);
      } else if (index === -1) this.checkedList.push(data);
      else this.checkedList.splice(index, 1);
    },
    SET_SUBMIT(e) {
      e.preventDefault();
      if (this.searchTimeout !== -1) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.$emit("change:search", this.search);
        this.EMIT_REQUEST("change:search");
      }, 1000);
    },
  },
  components: {
    Header,
    Body,
    BaseInput,
    Pagination,
    Chip,
    Drawer,
    Button,
    NotAuth,
  },
  mounted() {
    this.scopedSlots = Object.keys(this.$scopedSlots);
    if (this.count === 0) this.countItem = this.items.length;
    else this.countItem = this.count;
    this.search = this.searchValue;
    this.checkedList = this.checkValue;
    this.headersData = this.headers;
    if (this.scopedSlots.includes("filter")) this.filterSlot = true;
    if (this.scopedSlots.includes("new-button")) this.newButtonSlot = true;
    if (this.scopedSlots.includes("contextmenu"))
      this.isVisibleContextmenu = true;
    setTimeout(() => {
      this.init = true;
    }, 250);
  },
};
</script>
